import { environment } from '@analytics/env/environment';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { SENTRY_IGNORE_ERRORS, sentryBeforeSend } from '@agilox/sentry';
import { throwError } from 'rxjs';

import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import annotationPlugin from 'chartjs-plugin-annotation';
import { Chart } from 'chart.js';

Chart.register(TreemapController, TreemapElement, annotationPlugin);

if (environment.production) {
	enableProdMode();

	Sentry.init({
		dsn: 'https://365f2b8e42474552956ab461c1018946@o919676.ingest.sentry.io/5864005',
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				networkDetailAllowUrls: ['https://api.agilox.net'],
				networkCaptureBodies: true,
			}),
		],
		tracePropagationTargets: ['https://analytics.agilox.net'],
		ignoreErrors: SENTRY_IGNORE_ERRORS,
		beforeSend: sentryBeforeSend,
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		tracesSampleRate: 0.5,
		/**
		 * This causes the envelope size to be too big in some cases
		 * e.g. fleet-overview, replay
		 * Should only be uncommented when needed!
		 * https://develop.sentry.dev/sdk/envelopes/#size-limits
		 * /
		beforeBreadcrumb: (breadcrumb: Sentry.Breadcrumb, hint: Sentry.BreadcrumbHint) => {
			if (breadcrumb.category === 'xhr') {
				breadcrumb.data = (hint['xhr'] as XMLHttpRequest).response;
				const data = {
					requestBody: hint['xhr'].__sentry_xhr_v3__.body,
					response: hint['xhr'].response,
					responseUrl: hint['xhr'].responseURL,
				};
				return { ...breadcrumb, data };
			}
			return breadcrumb;
		},
		**/
	});
}

bootstrapApplication(AppComponent, {
	...appConfig,
	providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => throwError(err));
